// Article #4 supporting images — hosted WebP assets
export const SUPPORTING_IMAGE_COMPARISON_DATA_URI =
  "https://vibe.filesafe.space/1790702435770123164/assets/450e97bd-e461-4aa7-89c4-f76cff10c947.webp";
export const SUPPORTING_IMAGE_SELECTION_DATA_URI =
  "https://vibe.filesafe.space/1790702435770123164/assets/9873984d-931e-4104-a64f-eb9c5f931d52.webp";
